<template>
  <van-tabs
    ref="tabs"
    type="card"
    background="#bbb"
    color="#63d99f"
    title-inactive-color="#fff"
    :class="$style.wrap"
    @change="onChange"
  >
    <van-tab title="手机游戏">
      <base-game-list :list="mobile" />
    </van-tab>
    <van-tab title="客户端游戏">
      <base-game-list :list="pc" />
    </van-tab>
  </van-tabs>
</template>

<script>
import BaseGameList from "../components/BaseGameList";
import { ratio } from "@/utils/tools";

export default {
  name: "TheGames",
  components: { BaseGameList },
  props: {
    data: Object
  },
  computed: {
    mobile() {
      return this.data.mobile;
    },
    pc() {
      return this.data.pc;
    }
  },
  methods: {
    onChange() {
      const top = this.$refs.tabs.$el.offsetTop - 110 * ratio();
      document.body.scrollTop = top;
      document.documentElement.scrollTop = top;
    }
  }
};
</script>

<style module lang="less">
@nav-height: 0.92rem;

.wrap {
  margin-top: 2em;
  padding-top: 0;

  :global {
    .van-tabs__wrap {
      height: @nav-height;
    }

    .van-tabs__nav--card {
      height: @nav-height;
      margin: 0;
      border: 0;
      border-radius: 0;
    }

    .van-tab {
      font-size: 0.3rem;
      line-height: @nav-height;
    }

    .van-tab--active::after {
      .justify-center();
      .size(5em, 0.05rem);
      content: "";
      position: absolute;
      bottom: 0.2rem;
      background-color: @white;
      box-shadow: 0px 2px 2px 0px fade(#fc3f7d, 12%);
    }
  }
}
</style>
